import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BusqCasosclinico, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { CasoClinicoPage } from 'src/app/models/entidad-page.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-administrador-casosclinicos',
  templateUrl: './administrador-casosclinicos.component.html',
  styleUrls: ['./administrador-casosclinicos.component.scss']
})
export class AdministradorCasosclinicosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  busquedaForm!: FormGroup;

  //casoclinicoPageInformacion: HttpPaginacion<CasoClinicoPage> | undefined;
  //casoclinicoPage: CasoClinicoPage[] = [];

  casoclinicoPageInformacion: HttpPaginacionBusqueda<BusqCasosclinico> | undefined;
  casoclinicoPage: BusqCasosclinico[] = [];

  constructor(private administradorService: AdministradorService, private fb: FormBuilder) {
    this.busquedaForm = this.crearFormBusqueda();
    this.obtenerInformacion(1);
  }
  onSubmit(): void {
    this.obtenerInformacion(1);
  }
  crearFormBusqueda(): FormGroup {
    return this.fb.group({
      folio: [''],
      serie: [''],
      paciente: [''],
      fecha: [''],
      nombre_hospital: [''],
      seccion_cuerpo: [''],
      nombre_medico: [''],
      apellido_paterno_medico: [''],
      apellido_materno_medico: [''],
      nombre_enfermera: [''],
      apellido_paterno_enfermera: [''],
      apellido_materno_enfermera: [''],
    });
  }
  obtenerInformacion(page: number): void {
    const busqueda = this.busquedaForm.value;
    this.administradorService.busquedaCasosClincos(busqueda, page)
      .subscribe(
        {
          next: (resp) => {
            this.casoclinicoPageInformacion = resp;
            this.casoclinicoPage = resp.data;

            this.first = (resp.current_page - 1) * resp.per_page;
            this.rows = resp.per_page;
            this.totalRecords = resp.total;
          },
          error: (err) => console.log(err)
        }
      );


    /*
      this.administradorService.casosclinicos(page)
        .subscribe(
          {
            next: (resp) => {
              //     this.casoclinicoPageInformacion = resp;
              //     this.casoclinicoPage = resp.data;
  
              this.first = (resp.current_page - 1) * resp.per_page;
              this.rows = resp.per_page;
              this.totalRecords = resp.total;
            },
            error: (err) => console.log(err)
          }
        ); */
  }


  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
  }
  exportExcel(): void {
    const url = environment.urlBackPublic + environment.xlsxs.datosGeneralesCasosClinicos;
    window.open(url, "_blank");
  }
}
